import * as React from 'react';
export const MZSvg = React.forwardRef(function MZSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#159570',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 9h16v1c0 1.112-.5 2-1.994 2H1.994C.894 12 0 11.105 0 10V9Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 9v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V8H0v2c0 .5.5 2 2 2h12c1.579 0 2-.733 2-2V9h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 3h16v1H0V3Zm0 5h16v1H0V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M15 4V3h1v1h-1Zm0 5V8h1v1h-1Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M0 4h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M.649 11.473A2.01 2.01 0 0 1 0 9.991V2.01C0 1.419.253.889.656.52A.5.5 0 0 1 .8.596l7.2 5.4-7.2 5.4a.5.5 0 0 1-.151.077Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        fillRule: 'nonzero',
        d: 'm4.747 5.302-1.14.003a.158.158 0 0 1-.15-.11l-.353-1.084a.158.158 0 0 0-.302 0l-.351 1.084a.158.158 0 0 1-.151.11H1.16a.158.158 0 0 0-.093.286l.922.67c.055.04.079.112.057.178l-.352 1.084a.158.158 0 0 0 .245.177l.921-.618a.16.16 0 0 1 .187 0l.922.618a.158.158 0 0 0 .245-.177L3.86 6.439a.158.158 0 0 1 .057-.178l.922-.67a.16.16 0 0 0-.093-.29Z',
      }),
    ),
  );
});
MZSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MZ = {
  category: 'flag',
  colorable: false,
  name: 'MZ',
  svg: MZSvg,
};
